import { makeStyles } from '@material-ui/core/styles'

export default makeStyles(() => ({
  ul: {
    justfiyContent: 'space-around',
      // backgroundColor:'silver'

  },
}))
